import * as React from 'react';
import { MenuItem, Tooltip } from 'vet-bones/design-system/components';

import { useDownloadSdu } from 'src/ui/containers/endpoints/utils/useDownloadSdu';
import { Connection } from 'src/ui/graph/types';
import * as copy from 'src/ui/templates/copy';

interface SduMenuActionsProps {
  canReadLogs: boolean;
  connection: Connection;
  downloadTestId: string;
}

// Shared Download SDU menu item, rendered inside the host's <MenuItems>.
export const SduMenuActions: React.VFC<SduMenuActionsProps> = ({
  canReadLogs,
  connection,
  downloadTestId,
}) => {
  const downloadSdu = useDownloadSdu(connection);

  return (
    <Tooltip
      description={copy.components.endpoints.endpointTable.actions.downloadSduPermissionsTooltip(
        connection.name
      )}
      disabled={canReadLogs}
    >
      <MenuItem
        disabled={!canReadLogs}
        leftIcon={null}
        onClick={() => downloadSdu()}
        testId={downloadTestId}
        text={copy.components.endpoints.endpointTable.actions.downloadSdu}
      />
    </Tooltip>
  );
};
